import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPDATE_WORKSPACE_PRODUCT: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateWorkspaceProduct($input: UpdateWorkspaceProductInput!) {
    updateWorkspaceProduct(input: $input) {
      workspaceProduct {
        id
        product
        performanceReportUrl
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
